// Identidad verificada en Firebase Authentication. No es un permiso delegable por rol.
export const UID_CUENTA_LIMPIEZA='DM9ZCkenkGajrAsp4IXi2YMRyhG2';
export const esCuentaLimpieza=user=>user?.uid===UID_CUENTA_LIMPIEZA;
